import { useCallback, useState, useMemo } from 'react';
import * as permissionKind from '../../../../shared/permissions';
import hasPermissions from '../../../utilities/hasPermissions';
import NotFoundPage from '../../portal/NotFoundPage';
import ColorBlockTab from './ColorBlockTab';
import DetailsTab from './DetailsTab';
import OptionsBlockTab from './OptionsBlockTab';
import PackageBlockTab from './PackageBlockTab';
import TrimBlockTab from './TrimBlockTab';
import { HeaderTabs } from './utils';
import { useVariantConfigurator } from './VariantConfiguratorContext';

const VariantConfiguratorTabRenderer = () => {
    const [activeTab, setActiveTab] = useState<HeaderTabs>(HeaderTabs.Details);
    const { variantConfigurator } = useVariantConfigurator();

    const replaceTab = useCallback((value: HeaderTabs) => {
        setActiveTab(value);
    }, []);

    const tabProps = useMemo(() => ({ replaceTab, activeTab }), [activeTab, replaceTab]);
    const hasUpdatePermission = useMemo(
        () => hasPermissions(variantConfigurator.permissions, [permissionKind.updateConfigurator]),
        [variantConfigurator.permissions]
    );

    switch (activeTab) {
        case HeaderTabs.Colors:
            return <ColorBlockTab disabled={!hasUpdatePermission} {...tabProps} />;

        case HeaderTabs.Trims:
            return <TrimBlockTab disabled={!hasUpdatePermission} {...tabProps} />;

        case HeaderTabs.Packages:
            return <PackageBlockTab disabled={!hasUpdatePermission} {...tabProps} />;

        case HeaderTabs.Options:
            return <OptionsBlockTab disabled={!hasUpdatePermission} {...tabProps} />;

        case HeaderTabs.Details:
            return <DetailsTab disabled={!hasUpdatePermission} {...tabProps} />;

        default:
            return <NotFoundPage />;
    }
};

export default VariantConfiguratorTabRenderer;
